import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'
import { GetFinalizeSurgicalOrdersHistory } from 'domain/usecases/surgical-order/get-finalize-surgical-orders-history'

export class RemoteGetFinalizeSurgicalOrdersHistory
  implements GetFinalizeSurgicalOrdersHistory
{
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  load(params: GetFinalizeSurgicalOrdersHistory.Params) {
    return this.surgicalOrderRepository.getFinalizeSurgicalOrdersHistory(params)
  }
}
